'use client';
import { useOverflowSnapshot } from "./useOverflowSnapshot.js";
/**
 * A hook that returns the visibility status of all items and groups.
 *
 * ⚠️ Heads up!
 *
 * This hook will cause the component it is in to re-render for every single time an item overflows or becomes
 * visible - use with caution
 * @returns visibility status of all items and groups
 */ export function useOverflowVisibility() {
    const snapshot = useOverflowSnapshot(selectSnapshot);
    return {
        itemVisibility: snapshot.itemVisibility,
        groupVisibility: snapshot.groupVisibility
    };
}
const selectSnapshot = (snapshot)=>snapshot;
